import * as React from 'react';
import { Link } from 'react-router-dom';
import '../Campaigns.css';
import * as Moment from 'moment-timezone'
import * as controller from '../../campaign/controller'
import { withLocalize } from "react-localize-redux";
import ReactTable from 'react-table'
import 'react-table/react-table.css'
class Archive extends React.Component<any, any> {
  removeCampaign: any

  constructor(props: any) {
    super(props);
    this.state = {
      campaigns: []
    }
    this.loadCampaigns = this.loadCampaigns.bind(this)
    this.removeCampaign = controller.removeCampaign.bind(this)

  }


  loadCampaigns() {
    fetch('campaigns/getAllCompleted', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaigns = data.campaigns
        this.setState({campaigns})
    }).catch(err => {
      alert(err.message);
    })
  }


  componentWillMount() {
    this.loadCampaigns()
  }



  public render() {
    let account = window.account

    const columns = [{
      Header: '#',
      accessor: 'id',
      maxWidth: 80,
      resizable: false
    }, {
      Header: this.props.translate("campaign.name").toString(),
      accessor: 'title'
    }, {
      id: "participents",
      Header: this.props.translate("campaign.participentsTotal").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
           {row.value.participating}/{row.value.maxUsers}
          </span>
        )
      },
    },{
      id: "start",
      Header: this.props.translate("campaign.start").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
           {Moment.tz(row.value.startDate, process.env.REACT_APP_TIMEZONE || "").format("DD/MM/YYYY")}
          </span>
        )
      },
    },{
      id: "end",
      Header: this.props.translate("campaign.end").toString(),
      accessor: (d:any) => d,
      Cell: (row:any) => {
        return (
          <span>
           {Moment.tz(row.value.endDate, process.env.REACT_APP_TIMEZONE || "").format("DD/MM/YYYY")}
          </span>
        )
      },
    },{
      id: 'settings',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      maxWidth: 140,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/campaigns/" + row.value.id}><i className="fas fa-edit"></i></Link>
        <Link to={"/campaigns/"+row.value.id+"/stats"}><i className="fas fa-chart-line"></i></Link>
        {account.type == "admin" && account.privilege == "admin" && <i onClick={this.removeCampaign.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>}
      </div>
    }]

    return (
      <div id="tasks-root">

      <div className="board">
        <ReactTable
          data={this.state.campaigns}
          columns={columns}
          defaultPageSize={10}
          noDataText={this.props.translate("noResults").toString()}
          nextText={this.props.translate("next").toString()}
          previousText={this.props.translate("previous").toString()}
          rowsText={this.props.translate("rows").toString()}
          pageText={this.props.translate("page").toString()}
          ofText={this.props.translate("of").toString()}
          style={{
            height: "400px",
            textAlign: "center",
            fontSize: "1em",
            position: "centner",
            right: "0",
            left: "0",
            margin: "0 auto"
          }}
          className="-striped -highlight reactTable"
        />
      </div>

      </div>
    )
  }

}

export default withLocalize(Archive)



// WEBPACK FOOTER //
// ./src/pages/campaigns/archive/Archive.tsx